;(function () {
	var canvas = document.getElementById( 'frm-signature' );

	canvas.width = canvas.closest( '.form-field' ).clientWidth;

	const signatureDataField = canvas.closest( 'div' ).querySelector( 'input' );

	var signaturePad = new SignaturePad(canvas, {
		onEnd: function ( e ) {
			signatureDataField.value = signaturePad.toDataURL();
		}
	});

	if ( signatureDataField.value ) {
		signaturePad.fromDataURL( signatureDataField.value );
	}

	canvas.parentNode.querySelector( 'button' )
		.addEventListener( 'click', e => {
			e.preventDefault();
			signaturePad.clear();
		});

	var form = canvas.closest( 'form' );

	form.querySelector( '[type="submit"]' ).addEventListener( 'click', function ( e ) {
		e.preventDefault();

		if ( 'Hold until incomplete has been removed in course(s):' === jQuery( '[name="when"]:checked' ).val() ) {
			jQuery( '[name="incomplete-courses"]' ).attr( 'required', true );
			jQuery( '[name="hold-for"]' ).removeAttr( 'required' );
		} else if ( 'Hold for present grades:' === jQuery( '[name="when"]:checked' ).val() ) {
			jQuery( '[name="incomplete-courses"]' ).removeAttr( 'required' );
			jQuery( '[name="hold-for"]' ).attr( 'required', true );
		} else {
			jQuery( '[name="incomplete-courses"]' ).removeAttr( 'required' );
			jQuery( '[name="hold-for"]' ).removeAttr( 'required' );
		}

		let otherPrograms = false;

		jQuery( '[name="programs[]"]:checked' ).each( ( _, elem ) => {
			if ( 'Other' === jQuery( elem ).val() ) {
				otherPrograms = true;
			}
		});

		jQuery( '[name="programs-other"]' ).attr( 'required', otherPrograms );

		if ( ! form.checkValidity() ) {
			form.reportValidity();
		} else if ( signaturePad.isEmpty() ) {
			jQuery( canvas ).parent().find( '.error-message' ).remove();
			showErrorMessage( 'Signature is required.', canvas );
			jQuery( canvas ).parent().find( '.error-message' )[0].scrollIntoView();
		} else {
			if ( window.grecaptcha ) {
				window.grecaptcha.execute();
			} else {
				form.submit();
			}
		}
	});

	var addAddressBtn = form.querySelector( '[name="another_address"]' );
	var addresses = addAddressBtn.closest( '.form-wrapper' );
	var addressesTempl = document.getElementById( 'additional-addresses' );
	var addressCount = 0;

	function addAddress ( address ) {
		addressCount++;

		const clone = addressesTempl.content.cloneNode( true );
		clone.querySelectorAll( 'input' ).forEach( function ( elem ) {
			const oldName = elem.getAttribute( 'data-name' );
			const newName = oldName.replace( '[]', `[${addressCount}]` );
			const postName = elem.getAttribute( 'data-post-name' );
			elem.setAttribute( 'name', newName );

			if ( address && address[ postName ] ) {
				elem.value = address[ postName ];
			}
		});
		addresses.insertBefore( clone, addAddressBtn.parentNode );
	}

	const existingAddresses = JSON.parse( form['_addresses']?.value || "{}" );

	jQuery.each( existingAddresses, function ( _, address ) {
		addAddress( address );
	});

	addAddressBtn.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		addAddress();
	});

	jQuery( addresses ).on( 'click', '.additional-address__remove', function ( e ) {
		e.preventDefault();
		console.log( 'clicked' );
		jQuery( this ).parent().remove();
	});

	// window.Nette.showFormErrors = function ( form, errors ) {
	// 	form.querySelectorAll( '.error-message' ).forEach( el => el.remove() );

	// 	errors.forEach( err => {
	// 		err.element.classList.add( 'is-invalid' );

	// 		if ( err.message ) {
	// 			showErrorMessage( err.message, err.element );
	// 		}
	// 	});

	// 	if ( signaturePad.isEmpty() ) {
	// 		showErrorMessage( 'Signature is required.', canvas );
	// 	}

	// 	if ( 0 < errors.length ) {
	// 		errors[0].element.focus();
	// 	} else if ( signaturePad.isEmpty() ) {
	// 		canvas.parentNode.scrollIntoView();
	// 	} else {
	// 		grecaptcha.execute();
	// 	}
	// };

	function showErrorMessage( message, element ) {
		const errorElement = document.createElement( 'span' );
		const errorMessage = document.createTextNode( message );
		errorElement.appendChild( errorMessage );
		errorElement.classList.add( 'error-message' );
		element.insertAdjacentElement(
			'beforebegin',
			errorElement
		);
	}

	jQuery( function () {
		const programFields = document.querySelectorAll( 'input[name="programs[]"]' );
		jQuery( programFields ).each( ( _, elem ) => {
			elem.required = true;
		}).on( 'change', function ( _ ) {
			let checked = false;

			jQuery( programFields ).each( ( _, elem ) => {
				if ( elem.checked ) {
					checked = true;
				}
			});
			jQuery( programFields ).each( ( _, elem ) => {
				elem.required = ! checked;
				console.log( 'set programs required', ! checked );
			});
			console.log( 'programs change fired' );
		}).trigger( 'change' );

		const certField = document.querySelector( 'input[name="certification"]' );
		const degreeFields = document.querySelectorAll( 'input[name="degree"]' );
		certField.required = true;
		jQuery( degreeFields ).each( ( _, elem ) => {
			elem.required = true;
		}).on( 'change', _ => {
			let checked = false;

			jQuery( degreeFields ).each( ( _, elem ) => {
				if ( elem.checked ) {
					checked = true;
				}
			});

			certField.required = ! checked;

			if ( checked ) {
				certField.checked = false;
			}
		}).trigger( 'change' );
		jQuery( certField ).on( 'change', _ => {
			jQuery( degreeFields ).each( ( _, elem ) => {
				elem.required = ! certField.checked;

				if ( certField.checked ) {
					elem.checked = false;
				}
			});
		}).trigger( 'change' );
	});
}());

jQuery( function () {

	const form = document.forms[ 'request-transcript-form' ];

	if ( ! form ) {
		return;
	}

	const emails = document.getElementById( 'frm-mailto_emails' )?.closest( 'fieldset' );
	const mail = document.getElementById( 'frm-mailto_company' )?.closest( 'fieldset' );

	form.email_transcript_to.addEventListener( 'change', function () {

		if ( 'mail' === this.value ) {
			emails.setAttribute( 'hidden', '' );
			mail.removeAttribute( 'hidden' );
		} else {
			emails.removeAttribute( 'hidden' );
			mail.setAttribute( 'hidden', '' );
		}

	} );

} );
